interface BedIconOptions {
    cssClasses?: string
}

export function IconBed(props: BedIconOptions) {
    return (
        <svg id="ee5b3d62-b21a-4a54-85c2-68fe6c373b52" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" className={props?.cssClasses}>
            <circle className="abf64dff-2d18-442f-b9c9-f8fe8a9738b1" cx="5" cy="4" r="2"/>
            <path className="abf64dff-2d18-442f-b9c9-f8fe8a9738b1" d="M16,8H8V5h6a2,2,0,0,1,2,2Z" transform="translate(0 -2)"/>
            <path className="abf64dff-2d18-442f-b9c9-f8fe8a9738b1" d="M16,9H2V2H0V14H2V12H14v2h2Z" transform="translate(0 -2)"/>
        </svg>
    )
}
